import React from "react";
import { Link, animateScroll as scroll } from "react-scroll";
import MainLogo from '../../images/z1.png';

function Header() {

  const toggleHome = () => {
    scroll.scrollToTop();
  }


  return (
    <div id="navbar-example"> 
     
    
    <nav className="navbar fixed-top navbar-expand-lg navbar-light" style={{minHeight:"100px"}} >
    
    <img className="spec" src={MainLogo} onClick={toggleHome}  alt="Main Logo" style={{width : "200px"}}/>
  <button className="navbar-toggler  navbar-dark" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo02" aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
    <span className="navbar-toggler-icon"></span>
  </button>

  <div className="collapse navbar-collapse " id="navbarTogglerDemo02">
    <ul className="navbar-nav ml-auto mt-2 mt-lg-0 scrollable-items " style={{cursor:"pointer",fontFamily: 'Roboto'}}>
    
    <Link 
    activeClass="active"
    to="aboutus"
    spy={true}
    smooth={true}
    offset={-120}
    duration={500}
    style={{margin:"10px"}}
    
>About</Link>
 
<Link 
    activeClass="active"
    to="services"
    spy={true}
    smooth={true}
    offset={-120}
    duration={500}
    style={{margin:"10px"}}
    
>Services</Link>

<Link 
    activeClass="active"
    to="portfolio"
    spy={true}
    smooth={true}
    offset={-180}
    duration={500}
    style={{margin:"10px"}}
    
>Portfolio</Link>

<Link  
    activeClass="active"
    to="contact"
    spy={true}
    smooth={true}
    offset={-120}
    duration={500}
    style={{margin:"10px"}}
    
>Contact</Link>
    
    </ul>
  </div>
</nav>

</div>
  );
}

export default Header;
